<template>
  <div class="mb-10">
    <div class="display-1 font-weight-light">
      <span class="pl-5">Životopis</span>
      <v-divider></v-divider>
    </div>

    <p class="pa-5 pb-0 font-italic font-weight-light">
      Plnou verzi strukturovaného CV v PDF formátu je možno stáhnout zde:
      <a href="/files/Jiri_Pazdernik_CV_cz.pdf" target="_blank">
        <v-icon>mdi-open-in-new</v-icon>
        <span>Jiri_Pazdernik_CV_cz.pdf</span>
      </a>
      .
    </p>

    <div class="pl-5 pr-5 mt-5">
      <div class="headline">
        <span class="">Pracovní zkušenosti:</span>
      </div>

      <div class="ml-5">
        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">Vývojář, administrátor (živnost)</p>
        <p>2008 - současnost</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>vývoj, údržba a implementace internetových a intranetových aplikací a systemů</li>
          <li>
            participace na vývoji a implementaci rozsáhlých intranetových a zákaznických portálů
            nadnárodních telekomunikačních a finančních společností (Nokia, Allianz, Sazka, ČMSS)
          </li>
          <li>vývoj a správa databází</li>
          <li>analýza požadavků klientů pro vývoj a instalaci software</li>
          <li>instalace a administrace linuxových a BSD serverů</li>
          <li>
            refactoring softwareové infrasktruktury jednoho z největších tuzemských prodejců obuvi a
            doplňků – frontend i backend veřejného webového rozhraní a intranetové administrace
            (PHP Phalcon, JavaScript jQuery, MariaDB), implementace platebních metod (Kup Najisto,
            ČSOB POS Merchant…), software pro dotykové expediční a skladové terminály (Python),
            sklady, fakturace, propojení s externími účetními systémy, export dat pro porovnávače a
            vyhledávače (Google, Heuréka, Seznam…), refactoring databáze (normalizace, indexy,
            odstranění duplikovaných dat…)
          </li>
          <li>
            vývoj rozsáhlé aplikace pro nizozemského klienta pro podporu prodejních agentů a
            stávajících zákazníků různých společností (energie, telekomunikace); využívané technologie:
            Nette, Doctrine, Symfony console, NodeJS, Backbone JS framework, MySQL (pro řídící
            struktury) a MongoDB (data, maily, logy…), Docker, AMQP, RabbitMQ, testování v Nette
            Tester a Codeception, PHP Stan a řada dalších.
          </li>
        </ul>

        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">Alia Complete, spol. s r.o. (vývojář, administrátor)</p>
        <p>2007 - 2010</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>vývoj internetových a intranetových aplikací a systemů</li>
          <li>vývoj a správa databází</li>
          <li>instalace a administrace linuxových a BSD serverů</li>
          <li>návrh a implementace HA řešení, včetně failover zabezpečení a replikací databází</li>
        </ul>

        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">INGE Opava, spol. s r.o. (vývojář, grafik, technik)</p>
        <p>2000 - 2001</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>správa podnikové sítě a HW systémů (Windows, cca 50 PC)</li>
          <li>vývoj interních aplikací a interaktivních multimediálních prezentací pro Windows</li>
          <li>grafické návrhy podnikových informačních materiálů, letáky, katalogy</li>
          <li>zpracování technické dokumentace výrobků (osvětlovací systémy, cca 1200 typů produktů)</li>
          <li>3D modelování a renderování osvětlovacích systémů pro různá prostředí</li>
        </ul>

        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">Comtype Opava (vývojář, grafik, technik)</p>
        <p>1991 - 2007</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>DTP, grafické návrhy reklamních materiálů a rozličných tiskopisů, retuš fotografií</li>
          <li>vývoj internetových a intranetových aplikací a systémů</li>
          <li>vývoj a správa databází</li>
          <li>vývoj aplikací pro Windows a linuxové systémy</li>
          <li>montáž a opravy PC</li>
        </ul>
      </div>
    </div>

    <div class="pl-5 pr-5 mt-5">
      <div class="headline">
        <span class="">Další informace:</span>
      </div>

      <div class="ml-5">
        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">Znalosti v oblasti IT</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>Obecné znalosti – dlouhodobá praxe v obasti software a hardware</li>
          <li>
            Webové technologie – PHP (Zend, Phalcon, Nette, Symfony, Laravel), JavaScript (jQuery,
            Backbone, Vue), (X)HTML, CSS, XML, WSDL, WebServices, REST, GraphQL
          </li>
          <li>
            Testování – unit a akceptační testy (Nette Tester, Codeception)
          </li>
          <li>
            Databáze – PostgreSQL, MySQL (MariaDB), Sybase ASA/ASE, MongoDB
          </li>
          <li>
            Další programovací jazyky – Python, Pascal, Java, C++, skriptovací jazyky (BASH, DASH)
          </li>
          <li>
            Verzovací systémy – SVN, GIT
          </li>
        </ul>

        <p class="subtitle-1 mt-5 mb-0 font-weight-bold">Grafické programy</p>
        <ul class="mt-3 pl-8 font-weight-light">
          <li>Adobe PhotoShop</li>
          <li>Adobe Illustrator</li>
          <li>Corel DRAW</li>
          <li>Corel PHOTO Paint</li>
          <li>GIMP</li>
        </ul>
      </div>
    </div>
    <div class="pl-5 pr-5 mt-5">
      <div class="headline">
        <span class="">Absolvované kurzy a přednášky:</span>
      </div>

      <ul class="course mt-3 pl-9 font-weight-light">
        <li>Objektově orientované programování v praxi (2007)</li>
        <li>UML – návrh a vývoj, Enterprise Architect (2007)</li>
        <li>PostreSQL – správa, návrh DB a bezpečnost (2009)</li>
        <li>SybaseSQL 10 Anywhere Fundamentals (2010)</li>
        <li>PostgreSQL Developers Day (2012)</li>
        <li>PostgreSQL 9.x – administrace (2012)</li>
        <li>PostgreSQL Developers Day (2013)</li>
        <li>Unit testování, Akademie Root (2013)</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CuricVitae"
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 1px;
  }
  ul.course {
    list-style-type: none;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>